export enum UserInteractionType {

    MAKE_LEAD="MAKE_LEAD",
    DELETE_OPPORTUNITY="DELETE_OPPORTUNITY",
    FOLLOW_COMPANY="FOLLOW_COMPANY",
}
